export default __webpack_public_path__ + "static/media/img-0080-japan-full-face.6e38c516.png";